import "./AddPayouts.css";
import { useState } from "react";
import countriesData from "../../../../../data/countries.json";
const AddPayouts = ({ setActive }) => {
 const [country, setCountry] = useState("");
 const [accountNumber, setAccountNumber] = useState("");
 const [bank, setBank] = useState("");
 return (
  <div className="add-payouts">
   <p className="title">Country / Region</p>
   <div>
    <div className="form-container">
     <div className="input-container">
      <label htmlFor="country">Country</label>
      <select
       id="country"
       defaultValue={"Select country"}
       onChange={(e) => {
        setCountry(e.target.value);
       }}
      >
       <option default disabled>
        Select country
       </option>

       {countriesData.map((data, index) => {
        return (
         <option key={index} data-index="index" value={data.name}>
          {data.name}
         </option>
        );
       })}
      </select>
     </div>
    </div>
   </div>

   <p className="title bank">Bank Information</p>

   <div className="input-container">
    <label htmlFor="bank">Bank name</label>
    <select
     id="bank"
     defaultValue={"Select bank"}
     onChange={(e) => {
      setBank(e.target.value);
     }}
    >
     <option default disabled>
      Bank name
     </option>

     {countriesData.map((data, index) => {
      return (
       <option key={index} data-index="index" value={data.name}>
        {data.name}
       </option>
      );
     })}
    </select>
   </div>

   <div className="input-container">
    <label htmlFor="account-number">Account number</label>
    <input
     type="text"
     id="account-number"
     placeholder="Account number"
     value={accountNumber}
     onChange={(e) => setAccountNumber(e.target.value)}
    />
   </div>
   <div className="shapBtn-container">
    <p onClick={() => setActive("payouts")}>Cancel</p>
    <p className="shapBtn">Save</p>
   </div>
  </div>
 );
};

export default AddPayouts;
